import ExtraCurricular from '../components/profile/ExtraCurricular';
import api from './api';

// Get complete user profile
export const getUserProfile = async () => {
  try {
    const response = await api.get('/profile');
    const formattedEducationList = response.education.map(edu => ({
      id: edu.id,
      institutionName: edu.institution_name,
      degree: edu.degree,
      fieldOfStudy: edu.field_of_study || '',
      startDate: edu.start_date,
      endDate: edu.end_date,
      current: !edu.end_date,
      gpa: edu.gpa || '',
      coursework: edu.coursework || ''
    }));

    // Return both the original response and the formatted education list
    return {
      ...response,
      education: formattedEducationList,
    };
    // return response;
  } catch (error) {
    throw handleApiError(error);
  }
};


export const uploadResume = async (formData) => {
  try {

    const response = await api.uploadFile('/profile/upload-resume', formData);
    return response
  } catch (error) {

    throw handleApiError(error);
  }

}


export const checkUploadResumeStatus = async (jobId) => {
  try {
    const response = await api.get('profile/resume-processing-status/'+jobId);
    return response
  } catch (error) {

    throw handleApiError(error);
  }

}


// // Get complete user profile
// export const getUserProfile = async () => {
//   try {
//     const response = await api.get('/profile');
//     return response;
//   } catch (error) {
//     throw handleApiError(error);
//   }
// };

// Update profile summary
export const updateProfileSummary = async (summaryData, profileId) => {
  try {
    const response = await api.post(`/profile/${profileId}/summary`, summaryData);
    return response.data;
  } catch (error) {
    throw handleApiError(error);
  }
};

// Update complete profile
export const updateProfile = async (profileData) => {
  try {
    const response = await api.put(`/profile`, profileData);
    return response.data;
  } catch (error) {
    throw handleApiError(error);
  }
};

// Get social media profile
export const getSocialProfile = async (profileId) => {
  try {
    const response = await api.get(`/profile/${profileId}/social`);
    return response;
  } catch (error) {
    throw handleApiError(error);
  }
};

// Update social media profile
export const updateSocialProfile = async (socialData, profileId) => {
  try {
    const response = await api.put(`/profile/${profileId}/social`, socialData);
    return response;
  } catch (error) {
    throw handleApiError(error);
  }
};

// Create social media profile (if it doesn`t exist)
export const createSocialProfile = async (socialData, profileId) => {
  try {
    const response = await api.post(`/profile/${profileId}/social`, socialData);
    return response;
  } catch (error) {
    throw handleApiError(error);
  }
};


// Education endpoints
export const getEducation = async (profileId) => {
  try {
    const response = await api.get(`/profile/${profileId}/education`);
    return response.data;
  } catch (error) {
    throw handleApiError(error);
  }
};

export const addEducation = async (educationData, profileId) => {
  try {
    const response = await api.post(`/profile/${profileId}/education`, educationData);
    return response;
  } catch (error) {
    throw handleApiError(error);
  }
};

export const updateEducation = async (id, educationData, profileId) => {
  try {
    const response = await api.put(`/profile/${profileId}/education/${id}`, educationData);
    return response;
  } catch (error) {
    throw handleApiError(error);
  }
};

export const deleteEducation = async (id, profileId) => {
  try {
    const response = await api.delete(`/profile/${profileId}/education/${id}`);
    return response;
  } catch (error) {
    throw handleApiError(error);
  }
};

// Skills endpoints
export const getSkills = async (profileId) => {
  try {
    const response = await api.get(`/profile/${profileId}/skills`);
    return response.data;
  } catch (error) {
    throw handleApiError(error);
  }
};

export const addSkillGroup = async (skillData, profileId) => {
  try {
    const response = await api.post(`/profile/${profileId}/skills`, skillData);
    return response.data;
  } catch (error) {
    throw handleApiError(error);
  }
};

export const updateSkillGroup = async (id, skillData, profileId) => {
  try {
    const response = await api.put(`/profile/${profileId}/skills/${id}`, skillData);
    return response.data;
  } catch (error) {
    throw handleApiError(error);
  }
};

export const deleteSkillGroup = async (id, profileId) => {
  try {
    const response = await api.delete(`/profile/${profileId}/skills/${id}`);
    return response.data;
  } catch (error) {
    throw handleApiError(error);
  }
};

// Get all skill categories with their skills
export const getSkillCategories = async (profileId) => {
  try {
    const response = await api.get(`/profile/${profileId}/skill-categories`);
    return response;
  } catch (error) {
    throw handleApiError(error);
  }
};

// Create a new skill category
export const createSkillCategory = async (categoryData, profileId) => {
  try {
    const response = await api.post(`/profile/${profileId}/skill-categories`, categoryData);
    return response;
  } catch (error) {
    throw handleApiError(error);
  }
};

// Update an existing skill category
export const updateSkillCategory = async (categoryId, categoryData, profileId) => {
  try {
    const response = await api.put(`/profile/${profileId}/skill-categories/${categoryId}`, categoryData);
    return response;
  } catch (error) {
    throw handleApiError(error);
  }
};

// Delete a skill category
export const deleteSkillCategory = async (categoryId, profileId) => {
  try {
    const response = await api.delete(`/profile/${profileId}/skill-categories/${categoryId}`);
    return response;
  } catch (error) {
    throw handleApiError(error);
  }
};

// Add a skill to a category
export const addSkill = async (categoryId, skillData, profileId) => {
  try {
    const response = await api.post(`/profile/${profileId}/skill-categories/${categoryId}/skills`, skillData);
    return response;
  } catch (error) {
    throw handleApiError(error);
  }
};

// Update a skill
export const updateSkill = async (skillId, skillData, profileId) => {
  try {
    const response = await api.put(`/profile/${profileId}/skills/${skillId}`, skillData);
    return response;
  } catch (error) {
    throw handleApiError(error);
  }
};

// Delete a skill
export const deleteSkill = async (skillId, profileId) => {
  try {
    const response = await api.delete(`/profile/${profileId}/skills/${skillId}`);
    return response;
  } catch (error) {
    throw handleApiError(error);
  }
};

// Experience endpoints
export const getExperience = async (profileId) => {
  try {
    const response = await api.get(`/profile/${profileId}/experiences`);
    return response;
  } catch (error) {
    throw handleApiError(error);
  }
};

export const addExperience = async (experienceData, profileId) => {
  try {
    const response = await api.post(`/profile/${profileId}/experiences`, experienceData);
    return response;
  } catch (error) {
    throw handleApiError(error);
  }
};

export const updateExperience = async (id, experienceData, profileId) => {
  try {
    const response = await api.put(`/profile/${profileId}/experiences/${id}`, experienceData);
    return response;
  } catch (error) {
    throw handleApiError(error);
  }
};

// Add a responsibility to an experience
export const addExperienceResponsibility = async (experienceId, responsibilityData, profileId) => {
  try {
    const response = await api.post(`/profile/${profileId}/experiences/${experienceId}/responsibilities`, responsibilityData);
    return response;
  } catch (error) {
    throw handleApiError(error);
  }
};

// Update a responsibility
export const updateResponsibility = async (responsibilityId, responsibilityData, profileId) => {
  try {
    const response = await api.put(`/profile/${profileId}/responsibilities/${responsibilityId}`, responsibilityData);
    return response;
  } catch (error) {
    throw handleApiError(error);
  }
};

// Delete a responsibility
export const deleteResponsibility = async (responsibilityId, profileId) => {
  try {
    const response = await api.delete(`/profile/${profileId}/responsibilities/${responsibilityId}`);
    return response;
  } catch (error) {
    throw handleApiError(error);
  }
};

export const deleteExperience = async (id, profileId) => {
  try {
    const response = await api.delete(`/profile/${profileId}/experiences/${id}`);
    return response;
  } catch (error) {
    throw handleApiError(error);
  }
};

// Get all projects with their responsibilities and technologies
export const getProjects = async (profileId) => {
  try {
    const response = await api.get(`/profile/${profileId}/projects`);
    return response;
  } catch (error) {
    throw handleApiError(error);
  }
};

// Get a specific project by ID
export const getProjectById = async (projectId, profileId) => {
  try {
    const response = await api.get(`/profile/${profileId}/projects/${projectId}`);
    return response;
  } catch (error) {
    throw handleApiError(error);
  }
};

// Add a new project
export const addProject = async (projectData, profileId) => {
  try {
    const response = await api.post(`/profile/${profileId}/projects`, projectData);
    return response;
  } catch (error) {
    throw handleApiError(error);
  }
};

// Update an existing project
export const updateProject = async (id, projectData, profileId) => {
  try {
    const response = await api.put(`/profile/${profileId}/projects/${id}`, projectData);
    return response;
  } catch (error) {
    throw handleApiError(error);
  }
};

// Delete a project
export const deleteProject = async (id, profileId) => {
  try {
    const response = await api.delete(`/profile/${profileId}/projects/${id}`);
    return response;
  } catch (error) {
    throw handleApiError(error);
  }
};

// Add a responsibility to a project
export const addProjectResponsibility = async (projectId, responsibilityData, profileId) => {
  try {
    const response = await api.post(`/profile/${profileId}/projects/${projectId}/responsibilities`, responsibilityData);
    return response;
  } catch (error) {
    throw handleApiError(error);
  }
};

// Delete a project responsibility
export const deleteProjectResponsibility = async (responsibilityId, profileId) => {
  try {
    const response = await api.delete(`/profile/${profileId}/project-responsibilities/${responsibilityId}`);
    return response;
  } catch (error) {
    throw handleApiError(error);
  }
};

// Add a technology to a project
export const addProjectTechnology = async (projectId, technologyData, profileId) => {
  try {
    const response = await api.post(`/profile/${profileId}/projects/${projectId}/technologies`, technologyData);
    return response;
  } catch (error) {
    throw handleApiError(error);
  }
};

// Delete a project technology
export const deleteProjectTechnology = async (technologyId, profileId) => {
  try {
    const response = await api.delete(`/profile/${profileId}/project-technologies/${technologyId}`);
    return response;
  } catch (error) {
    throw handleApiError(error);
  }
};

// Certificates endpoints
export const getCertificates = async (profileId) => {
  try {
    const response = await api.get(`/profile/${profileId}/certificates`);
    return response;
  } catch (error) {
    throw handleApiError(error);
  }
};

export const addCertificate = async (certificateData, profileId) => {
  try {
    const response = await api.post(`/profile/${profileId}/certificates`, certificateData);
    return response;
  } catch (error) {
    throw handleApiError(error);
  }
};

export const updateCertificate = async (id, certificateData, profileId) => {
  try {
    const response = await api.put(`/profile/${profileId}/certificates/${id}`, certificateData);
    return response;
  } catch (error) {
    throw handleApiError(error);
  }
};

export const deleteCertificate = async (id, profileId) => {
  try {
    const response = await api.delete(`/profile/${profileId}/certificates/${id}`);
    return response;
  } catch (error) {
    throw handleApiError(error);
  }
};

// Get all extracurricular activities
export const getExtraCurricular = async (profileId) => {
  try {
    const response = await api.get(`/profile/${profileId}/extracurricular`);
    return response;
  } catch (error) {
    throw handleApiError(error);
  }
};

// Get a specific extracurricular activity by ID
export const getExtraCurricularById = async (activityId, profileId) => {
  try {
    const response = await api.get(`/profile/${profileId}/extracurricular/${activityId}`);
    return response;
  } catch (error) {
    throw handleApiError(error);
  }
};

// Add a new extracurricular activity
export const addExtraCurricular = async (activityData, profileId) => {
  try {
    const response = await api.post(`/profile/${profileId}/extracurricular`, activityData);
    return response;
  } catch (error) {
    throw handleApiError(error);
  }
};

// Update an existing extracurricular activity
export const updateExtraCurricular = async (id, activityData, profileId) => {
  try {
    const response = await api.put(`/profile/${profileId}/extracurricular/${id}`, activityData);
    return response;
  } catch (error) {
    throw handleApiError(error);
  }
};

// Delete an extracurricular activity
export const deleteExtraCurricular = async (id, profileId) => {
  try {
    const response = await api.delete(`/profile/${profileId}/extracurricular/${id}`);
    return response;
  } catch (error) {
    throw handleApiError(error);
  }
};

// Get all custom sections with their items
export const getCustomSections = async (profileId) => {
  try {
    const response = await api.get(`/profile/${profileId}/custom-sections`);
    return response;
  } catch (error) {
    throw handleApiError(error);
  }
};

// Get a specific custom section by ID
export const getCustomSectionById = async (sectionId, profileId) => {
  try {
    const response = await api.get(`/profile/${profileId}/custom-sections/${sectionId}`);
    return response;
  } catch (error) {
    throw handleApiError(error);
  }
};

// Create a new custom section
export const createCustomSection = async (sectionData, profileId) => {
  try {
    const response = await api.post(`/profile/${profileId}/custom-sections`, sectionData);
    return response;
  } catch (error) {
    throw handleApiError(error);
  }
};

// Update an existing custom section
export const updateCustomSection = async (sectionId, sectionData, profileId) => {
  try {
    const response = await api.put(`/profile/${profileId}/custom-sections/${sectionId}`, sectionData);
    return response;
  } catch (error) {
    throw handleApiError(error);
  }
};

// Delete a custom section
export const deleteCustomSection = async (sectionId, profileId) => {
  try {
    const response = await api.delete(`/profile/${profileId}/custom-sections/${sectionId}`);
    return response;
  } catch (error) {
    throw handleApiError(error);
  }
};

// Add an item to a custom section
export const addCustomSectionItem = async (sectionId, itemData, profileId) => {
  try {
    const response = await api.post(`/profile/${profileId}/custom-sections/${sectionId}/items`, itemData);
    return response;
  } catch (error) {
    throw handleApiError(error);
  }
};

// Update a custom section item
export const updateCustomSectionItem = async (itemId, itemData, profileId) => {
  try {
    const response = await api.put(`/profile/${profileId}/custom-section-items/${itemId}`, itemData);
    return response;
  } catch (error) {
    throw handleApiError(error);
  }
};

// Delete a custom section item
export const deleteCustomSectionItem = async (itemId, profileId) => {
  try {
    const response = await api.delete(`/profile/${profileId}/custom-section-items/${itemId}`);
    return response;
  } catch (error) {
    throw handleApiError(error);
  }
};

// Handle API errors
const handleApiError = (error) => {
  if (error.response) {
    // Server responded with an error status
    const { data, status } = error.response;

    return {
      message: data.message || 'Request failed',
      status,
      data
    };
  } else if (error.request) {
    // Request was made but no response received
    return {
      message: 'No response from server. Please check your connection.',
      status: 0
    };
  } else {
    // Something else happened while setting up the request
    return {
      message: error.message || 'An unexpected error occurred',
      status: 0
    };
  }
};